import { fabric } from 'fabric';
import { useEffect, useState } from 'react';

import ImageUtils from '@core/utils/ImageUtils';
import { useSelectedColor } from '@ee-api/colors-api/useSelectedColor';

const useSlabImgElement = (): HTMLImageElement => {
    const { selectedValue: selectedColor } = useSelectedColor();
    const [slabImgElement, setSlabImgElement] = useState<HTMLImageElement>(new Image());

    const getBase64ImageAndLoadInFabric = async (slabImageUrl = '/public/mock/images/white.jpg') => {
        try {
            const slabImageUrlInBase64 = await ImageUtils.getBase64FromURL(slabImageUrl);
            fabric.util.loadImage(slabImageUrlInBase64, (img) => {
                setSlabImgElement(img);
            });
        } catch (error) {
            // TODO: find a better way to handle image loading errors
            console.error(error);
        }
    };

    useEffect(() => {
        if (selectedColor?.slabImageUrl) {
            const slabImageUrl = ImageUtils.imgUrl(selectedColor.slabImageUrl.replace('-thumbnail', ''), 2400);
            getBase64ImageAndLoadInFabric(slabImageUrl);
        } else {
            getBase64ImageAndLoadInFabric();
        }
    }, [selectedColor?.slabImageUrl]);

    return slabImgElement;
};

export default useSlabImgElement;
